import type { FC } from 'react';

import SearchInput from '@/components/shared/search-input';
import useStationSearch from '@/hooks/use-station-search';
import { LIST } from '@/utils/constants';

const StationListStickyContent: FC = () => {
  const { activeSearchKey, setActiveSearchKey } = useStationSearch(LIST);

  return <SearchInput onChange={setActiveSearchKey} initialValue={activeSearchKey} />;
};

export default StationListStickyContent;
